<template>
  <v-dialog v-model="waiter" width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        app
        color="primary"
        v-on="on"
        fixed
        bottom
        right
        fab
        :class="{ shake: shake }"
        @animationend="shake = false"
      >
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn>
    </template>

    <v-card flat class="pa-3">
      <v-card-title
        :class="{
          'grey--text': true,
          'text--darken-2': !isDark,
          'text--lighten-2': isDark
        }"
      >{{ $t("Call waiter?") }}</v-card-title>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" text @click="waiter = false">
          {{
          $t("Cancel")
          }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="
            callWaiter();
            waiter = false;
            shake = true;
          "
        >{{ $t("Call") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Activity from "@/model/activity";
export default {
  name: "WaiterButton",

  data: function() {
    return {
      waiter: false,
      shake: false
    };
  },

  computed: {
    isDark() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
  },
  methods: {
    callWaiter() {
      let activity = Activity.fromMap({
        location: this.$store.state.location,
        type: "callwaiter",
        date: new Date()
      });

      this.$gtag.event("call_waiter", {
        location: this.$store.state.location,
        locationName: this.$store.state._locationObject.name,
        restaurantId: this.$store.state.restaurantId
      });

      activity.save();
    }
  }
};
</script>

<style>
.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
